
import { NavItem } from "@school/a2z-lib";
import { environment } from '../../../environments/environment'

export const MainMenuItems: NavItem[] = [
  {
    title: 'Users',
    subtitle: 'Manage Application and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/application.svg',
    urlLink: '/' + environment.apiVersion + '/main',
  },
  {
    title: 'Account',
    subtitle: 'Profile, User details and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/verified-account.svg',
    urlLink: '/' + environment.apiVersion + '/myprofile',
  },
  {
    title: 'Settings',
    subtitle: 'Password, 2FA & Preference',
    status: '',
    icon: './assets/media/svg/icons/a2z/shield.svg',
    urlLink: '/' + environment.apiVersion + '/settings',
  },
];

export const A2ZUSMenuItems: NavItem[] = [
  {
    title: 'Apps',
    subtitle: 'Manage Application and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/application.svg',
    urlLink: '/' + environment.apiVersion + '/main',
  },
  {
    title: 'A2Z US Provider',
    subtitle: 'Manage Provider Details and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/doctor.svg',
    urlLink: '/' + environment.apiVersion + '/provider',
  },
  {
    title: 'A2Z US Patients',
    subtitle: 'Manage Patient Details and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/networking.svg',
    urlLink: '/' + environment.apiVersion + '/patient',
  },
  {
    title: 'Account',
    subtitle: 'Profile, User details and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/verified-account.svg',
    urlLink: '/' + environment.apiVersion + '/myprofile',
  },
  {
    title: 'Settings',
    subtitle: 'Password, 2FA & Preference',
    status: '',
    icon: './assets/media/svg/icons/a2z/shield.svg',
    urlLink: '/' + environment.apiVersion + '/settings',
  },
];

export const EagleMenuItems: NavItem[] = [
  {
    title: 'Apps',
    subtitle: 'Manage Application and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/application.svg',
    urlLink: '/' + environment.apiVersion + '/main',
  },
  {
    title: 'Hospital Eagle Group',
    subtitle: 'Manage Hospital Details and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/hospital_gp.svg',
    urlLink: '/' + environment.apiVersion + '/eagle_hospital_group',
  },
  {
    title: 'Hospital Eagle',
    subtitle: 'Manage Hospital Details and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/hospital.svg',
    urlLink: '/' + environment.apiVersion + '/eagle_hospital',
  },
  {
    title: 'Provider Eagle',
    subtitle: 'Manage Provider Details and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/doctor.svg',
    urlLink: '/' + environment.apiVersion + '/eagle_provider',
  },
  {
    title: 'Provider Eagle Group',
    subtitle: 'Manage Provider Details and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/doctor_group.svg',
    urlLink: '/' + environment.apiVersion + '/eagle_provider_group',
  },
  {
    title: 'Eagle Contract',
    subtitle: 'Manage Contract Details and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/contract.svg',
    urlLink: '/' + environment.apiVersion + '/eagle_contract',
  },
  {
    title: 'Account',
    subtitle: 'Profile, User details and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/verified-account.svg',
    urlLink: '/' + environment.apiVersion + '/myprofile',
  },
  {
    title: 'Settings',
    subtitle: 'Password, 2FA & Preference',
    status: '',
    icon: './assets/media/svg/icons/a2z/shield.svg',
    urlLink: '/' + environment.apiVersion + '/settings',
  },
];
